const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
export const gstRegex =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/;

const udyamRegex = /^[0-9A-Z]{16}$/;
const phoneNumberRegex = /^\d{10}$/;
const indianPhoneNumberRegex = /^[6-9]\d{9}$/;

export function checkIsValidPhoneNumber(phoneNumber: string) {
  return phoneNumberRegex.test(phoneNumber);
}

export const isValidIndianPhoneNumber = (value: string) =>
  indianPhoneNumberRegex.test(value);

export function checkIsValidPanFunc(pan: string) {
  return panRegex.test(pan);
}

export function isValidGst(gst: string) {
  return gstRegex.test(gst);
}

export function isValidGSTForPAN(
  gstNumber: string,
  panNumber: string
): boolean {
  // Extract the first 5 characters from the GST number
  const gstPanSubString = gstNumber.substr(2, 10);
  // Check if the extracted prefix matches the PAN number
  return gstPanSubString === panNumber;
}

export function isValidUdyamNumber(udyamNumber: string): boolean {
  return udyamRegex.test(udyamNumber);
}

export const isValidIfsc = (value: string) =>
  /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value);
export const isValidAccountNumber = (value: string) =>
  /^[0-9]{9,18}$/.test(value);
